import { WriteHook, useMutationManager } from 'react-query-state-manager'

import { submitDocumentRequestStep } from 'commons/service/bank/application'

export const useSubmitDocumentRequestStep: WriteHook<number, void> = (opts) =>
  useMutationManager<number, void>(submitDocumentRequestStep, opts)
